import CONTENTO_TYPES from '../../app/domain/ContentoTypes';

function normalizeUrl(str) {
    return str.replace(/[\/]+/g, '/').replace(/\/\?/g, '?').replace(/\/\#/g, '#').replace(/\:\//g, '://');
}

export function pathNoQueryHash(path) {
    const queryIndex = path.indexOf('?');
    const hashIndex = path.indexOf('#');

    if (queryIndex > -1 || hashIndex > -1) {
        path = path.substring(0, queryIndex > -1 ? queryIndex : hashIndex);
    }

    return path;
}

/**
 * Simple URL join. Join all string parameters as a URL. Does a simple normalizes aswell.
 * @returns {string} the url
 */
export function join() {
    const args = [].slice.call(arguments, 0).filter((val) => val !== undefined && val !== '');

    return normalizeUrl(args.join('/'));
}

function noAccents(str) {
    if (!str) {
        return '';
    }

    return str
        .toLowerCase()
        .replace(/[àáâãäåāąă]/g, 'a')
        .replace(/[çćčĉċ]/g, 'c')
        .replace(/[ďđð]/g, 'd')
        .replace(/[èéêëēęěĕė]/g, 'e')
        .replace(/[ƒſ]/g, 'f')
        .replace(/[ĝğġģ]/g, 'g')
        .replace(/[ĥħ]/g, 'h')
        .replace(/[ìíîïīĩĭįı]/g, 'i')
        .replace(/[ĳĵ]/g, 'j')
        .replace(/[ķĸ]/g, 'k')
        .replace(/[łľĺļŀ]/g, 'l')
        .replace(/[ñńňņŉŋ]/g, 'n')
        .replace(/[òóôõöøōőŏœ]/g, 'o')
        .replace(/[Þþ]/g, 'p')
        .replace(/[ŕřŗ]/g, 'r')
        .replace(/[śšşŝș]/g, 's')
        .replace(/[ťţŧț]/g, 't')
        .replace(/[ùúûüūůűŭũų]/g, 'u')
        .replace(/[ŵ]/g, 'w')
        .replace(/[ýÿŷ]/g, 'y')
        .replace(/[žżź]/g, 'z')
        .replace(/[ß]/g, 'ss')
        .replace(/[&]/g, 'och')
        .replace(/[–—]/g, '-')
        .replace(/[\/]/g, '-');
}

function justCharacters(str) {
    return noAccents(str)
        .replace(/[^\w\s-]/g, '') // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
        .replace(/^-+|-+$/g, ''); // remove leading, trailing -
}

export function updateQuery(query, params) {
    return Object.assign({}, query, params);
}

export function slugify(str) {
    return justCharacters(noAccents(str).replace(/[\s:_\-\,\.]+/g, '-')); // swap any length of whitespace, underscore, hyphen characters with a single - or , or .
}

export function formatUrl(path, query = {}) {
    if (!path) {
        return '';
    }

    // TODO: encodeURIComponent and check that incoming queryparams are not already encoded
    const qs = Object.keys(query)
        .filter((key) => query[key] !== undefined && query[key] !== null)
        .map((key) => `${key}=${query[key]}`)
        .join('&');
    const separator = path.includes('?') ? '&' : '?';

    return `${path}${qs ? separator : ''}${qs}`;
}

export function createUrlFromEpisode(episode, articleId) {
    const attributes = episode.attributes;
    const id = articleId || attributes.articleId;

    if (attributes.single) {
        return join('/video/', id, '/', slugify(attributes.officialEpisodeTitle || ''));
    }

    return join(
        '/video/',
        id,
        '/',
        slugify(attributes.officialProgramTitle || ''),
        '/',
        attributes.slug || ''
    );
}

export function createUrlFromTitle(title) {
    return join('/', slugify(title.attributes.title));
}

export function createUrlFromContento(item) {
    const content = item.content;
    const parent = content.parent || {};

    switch (item.content.__typename) {
        case CONTENTO_TYPES.EPISODE:
            return join('/video/', content.variants[0].legacyId, '/', parent.slug, '/', item.legacySlug);
        case CONTENTO_TYPES.SINGLE:
            return join('/video/', content.variants[0].legacyId, '/', parent.slug);
        case CONTENTO_TYPES.CLIP:
            return join('/klipp', content.id, '/', item.legacySlug);
        default:
            return '';
    }
}

export function createClipUrlFromContento(id = '', name = '') {
    return join('/klipp', id, slugify(name));
}

export function createUrlFromCluster(cluster) {
    return join('/genre', cluster.slug);
}

export function createUrlWithoutEscenicSlug(type, id, urlFriendlyTitle, slug) {
    return join('/', type, id, urlFriendlyTitle, slug).replace(/\/$/, '');
}

export function isValidURL(url) {
    try {
        decodeURI(url);
    } catch (e) {
        return false;
    }

    return true;
}

export function removeLeadingForwardSlashes(path) {
    if (!path) {
        return path;
    }

    return path.replace(/^[\/]+/, '');
}

export function isExternalURL(url, localDomain = 'www.svtplay.se') {
    const matches = url.match(/^(?:(?:https?\:)?\/\/)?([^\/?#]+)(?:[\/?#]|$)/i);

    return matches && matches.length > 1 && matches[1] !== localDomain;
}

export function toLinkUrl(url) {
    return url && url.startsWith('https://www.svtplay.se') ? url.replace('https://www.svtplay.se', '') : url;
}

export function jumpToHash(hash) {
    if (hash && typeof hash === 'string' && hash !== '') {
        setTimeout(() => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView();
                element.focus();
            }
        }, 0);
    }
}

export const addQuery = (router, name, value) => {
    const location = Object.assign({}, router.getCurrentLocation());

    location.query[name] = value;
    router.push(location);
};

export const removeQuery = (router, ...queryNames) => {
    const location = Object.assign({}, router.getCurrentLocation());

    queryNames.forEach((q) => delete location.query[q]);
    router.push(location);
};
